import { usePageViewTracker } from 'hooks';
import { Error } from '../';

export const FourOhFour = () => {
  usePageViewTracker('404');
  return <Error messageText="We’re sorry, there was a problem loading that page. Please try again." />
}
